import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { ContactCreditType } from "@/gql/graphql";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { reverseContactCreditMutation } from "@/app/ContactCredits/GraphQL/contactCreditMutations";
import { ContactCreditListItem } from "@/app/ContactCredits/GraphQL/contactCreditListQuery";
import { toast } from "sonner";

export function useContactCreditActions(): ActionsHook<ContactCreditListItem> {
  const { mutateAsync: reverseCredit } = useGqlMutation(
    reverseContactCreditMutation,
  );

  return (contactCredit) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                label: "Reverse",
                color: "red",
                Icon: ArrowUturnLeftIcon,
                isHidden:
                  contactCredit.type !== ContactCreditType.Issued ||
                  contactCredit.reversal !== null,
                handleAction: async () => {
                  await reverseCredit({ id: contactCredit.id });
                  toast.success("Credit reversed");
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
